import React from 'react';

// Listago brand colors (see brand moodboard).
const BRAND_GREEN = '#2EAF66';

/**
 * The Listago price-tag glyph. It stands in for the "i" in the wordmark and
 * doubles as the standalone app mark: a green euro price tag with the dot of
 * the "i" floating above it.
 */
export const LogoMark: React.FC<{ className?: string; title?: string }> = ({
  className = 'h-8 w-auto',
  title = 'Listago',
}) => (
  <svg
    className={className}
    viewBox="0 0 32 84"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label={title}
  >
    {/* Dot of the "i" */}
    <circle cx="16" cy="9" r="8" fill={BRAND_GREEN} />
    {/* Price-tag body */}
    <rect x="3" y="22" width="26" height="59" rx="8" fill={BRAND_GREEN} />
    {/* Tag hole */}
    <circle cx="16" cy="34" r="3.2" fill="#ffffff" />
    {/* Euro symbol */}
    <text
      x="16"
      y="65"
      textAnchor="middle"
      fontFamily="Poppins, sans-serif"
      fontWeight="700"
      fontSize="30"
      fill="#ffffff"
    >
      €
    </text>
  </svg>
);

interface LogoProps {
  /** Wrapper classes (layout/spacing). */
  className?: string;
  /** Controls the wordmark size, e.g. `text-2xl`. */
  textClassName?: string;
  /** Show the "Intelligent planen. Clever sparen." tagline beneath the wordmark. */
  showTagline?: boolean;
  /** Tagline size/spacing classes. */
  taglineClassName?: string;
}

/**
 * The full Listago wordmark: "L" + price-tag "i" + "stago", optionally with
 * the brand tagline beneath. Anthrazit (#1F2937 = gray-800) on light, white on
 * dark — matching the brand moodboard.
 */
export const Logo: React.FC<LogoProps> = ({
  className = '',
  textClassName = 'text-2xl',
  showTagline = false,
  taglineClassName = 'text-xs tracking-wide',
}) => (
  <div className={`flex flex-col leading-none ${className}`}>
    <span
      className={`inline-flex items-end font-black tracking-tight text-gray-800 dark:text-white ${textClassName}`}
    >
      L
      <LogoMark className="w-[0.5em] h-[1.5em] mx-[0.01em] translate-y-[0.04em]" />
      stago
    </span>
    {showTagline && (
      <span className={`font-semibold text-emerald-500 mt-1 ${taglineClassName}`}>
        Intelligent planen. Clever sparen.
      </span>
    )}
  </div>
);

export default Logo;
